import { render, staticRenderFns } from "./MarkCapAlloc.vue?vue&type=template&id=87694834&scoped=true&"
import script from "./MarkCapAlloc.vue?vue&type=script&lang=js&"
export * from "./MarkCapAlloc.vue?vue&type=script&lang=js&"
import style0 from "./MarkCapAlloc.vue?vue&type=style&index=0&id=87694834&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87694834",
  null
  
)

export default component.exports